import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { decodeId } from "../../../../utils/hash";

import EmailConfirmation from "./components/EmailConfirmation";
import Activation from "./components/Activation";

export default function AccountActivation() {
    const {id} = useParams();
    const userId = id ?decodeId(id) : null;

    const [confirmedID, setConfirmedID] = useState(null);

    useEffect(() => {
        setConfirmedID(userId);
    }
    , [userId]);

    return (
        <>
            {!confirmedID ? (
                <EmailConfirmation setConfirmedID={setConfirmedID} />
            ) : (
                <Activation confirmedID={confirmedID} />
            )}
        </>
    );
}
